var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"swiper-container child"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.msg),function(item){return _c('div',{key:item.id,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.imgUrl}})])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }